import { createConsts, createActions } from '../../utils/redux';

import { isFlagler } from '../../constants/brandConfig';
import { THEMES } from '../../constants/styles';
import { isSupportedBrowser } from '../../utils/browserChecker';

export const consts = createConsts(
  'ui',
  'theme',
  'SET_THEME',
  'CLEAR',
  'SET_DEFAULT',
);
export const actions = createActions(consts);

const loggedIn = window.localStorage.getItem('loggedIn');
const communityPreview = window.localStorage.getItem('active-community-id');
const IS_BROWSER_SUPPORTABLE = isSupportedBrowser();

const initialState =
  isFlagler && !communityPreview && (!loggedIn || !IS_BROWSER_SUPPORTABLE)
    ? THEMES.FLAGLER
    : null;
const defaultState = isFlagler ? THEMES.FLAGLER : null;

export default (state = initialState, action) => {
  switch (action.type) {
    case consts.SET_THEME:
      return action.payload;
    case consts.SET_DEFAULT:
      return defaultState;
    case consts.CLEAR:
      return null;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/ui/theme.js